<template>
    <div>
        <h2>Admin</h2>

        <div v-if="!created">
            <div>Create New User</div>

            <form @submit.prevent="createUser">
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <b-icon-person-fill />
                        </span>
                    </div>

                    <input
                        type="text"
                        class="form-control"
                        placeholder="Username (email address)"
                        v-model="userId"
                    />
                </div>

                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <b-icon-person-fill />
                        </span>
                    </div>

                    <input
                        type="text"
                        class="form-control"
                        placeholder="Display Name"
                        v-model="displayName"
                    />
                </div>

                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <b-icon-lock-fill />
                        </span>
                    </div>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Password"
                        v-model="password"
                    />
                </div>

                <div v-if="errors.length > 0" class="input-group mb-3">
                    <div
                        v-for="(err, i) in errors"
                        v-bind:key="i"
                        class="alert alert-danger"
                    >
                        {{ err }}
                    </div>
                </div>

                <div>
                    <button type="submit" class="btn btn-primary">
                        Create User
                    </button>

                    <label style="margin-left: 1rem; margin-right: 0.5rem;">send notification email?</label>
                    <input
                        type="checkbox"
                        v-model="shouldSendEmail"
                    />
                </div>
            </form>
        </div>

        <div v-else>
            <div>User Created</div>
            <div class="input-group mb-3">{{ confirmText }}</div>

            <div class="input-group mb-3">
                <button @click="resetForm" class="btn btn-primary">
                    Create Another
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { BIconPersonFill, BIconLockFill } from "bootstrap-vue";
import generator from "generate-password";
import api from '@/api';

export default {
    name: "AdminPage",
    data: function () {
        return {
            userId: "",
            displayName: "",
            password: this.generatePassword(),
            shouldSendEmail: true,
            errors: [],
            created: false,
            confirmText: "",
        };
    },
    methods: {
        generatePassword() {
            return generator.generate({ length: 10, number: true });
        },

        async createUser() {
            this.errors = [];

            if (this.userId && this.displayName && this.password) {
                let newUser = {
                    userId: this.userId,
                    displayName: this.displayName,
                    password: this.password,
                    shouldSendEmail: this.shouldSendEmail
                };

                try {
                    let result = await this.addUser(newUser);
                    // do database stuff
                    if (result) {
                        this.confirmText = `username = ${newUser.userId}, password = ${newUser.password}`;
                        this.created = true;
                    }
                } catch (err) {
                    this.errors.push(`Unable to create user. ${err.message}`);
                }

                return;
            }

            if (!this.userId) this.errors.push("You must enter a username");
            if (!this.displayName)
                this.errors.push("You must enter a display name");
            if (!this.password) this.errors.push("You must enter a password");
        },

        async addUser(data) {
            let result = await api.users.create(data);

            let { error, message, results } = result;
            if (error) {
                throw new Error(message);
            }

            let { user } = results;
            return user;
        },

        resetForm() {
            this.userId = "";
            this.displayName = "";
            this.password = this.generatePassword();
            this.created = false;
            this.confirmText = "";
        },
    },

    components: {
        BIconPersonFill,
        BIconLockFill,
    },
};
</script>